<script setup lang="ts">
import type { Scadenza } from "@gasparigit/omnia-sdk";

defineProps<{
  content: Scadenza;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props">
    <template #info />
    <template #preview>
      <div
        v-if="content.date"
        class="font-mono flex flex-col text-tertiary items-start justify-center font-semibold text-base me-2 mb-2 md:mb-0"
      >
        <span class="text-3xl">{{ content.date.getDate() }}</span>
        <span>{{
          content.date.toLocaleString("default", { month: "long" })
        }}</span>
        <span>{{ content.date.getFullYear() }}</span>
      </div>
    </template>
  </FrontContentItemsBaseContent>
</template>
